<template>
  <el-dialog
  class="dialogCode dialogCustom"
  title="上传授权码的二维码图片"
  width="424px"
  v-bind="$attrs"
  :close-on-click-modal="false"
  :before-close="handleClose">
  <el-upload
    class="saveCode"
    drag
    action="#"
    :before-upload="checkFile"
    :show-file-list="false"
    :multiple="false"
    :disabled="uploadDisabled"
    :http-request="e => importData(e)">
    <img class="imgClass" src="../../../../assets/img/upload.svg" >
    <div class="textClass">支持拖拽上传，支持JPG、JPEG 、PNG，不超过2MB</div>
  </el-upload>
  <div class="errorMsg" v-show="errorMsg" v-html="errorMsg"></div>
  <span slot="footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="saveCode">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
import requestActiveLicense from "~/request/requestActiveLicense";
  export default {
    data() {
      return {
        uploadDisabled: false,
        errorMsg: '',
        codeValue: ''
      };
    },
    methods: {
      importData(event){
        let formData = new FormData();
        formData.append('qrCode', event.file, event.file.name);
        this.uploadDisabled = true;
        requestActiveLicense.parseQrCode(formData).then(res => {
          // this.loading = false;
          if (res.code === '0') {
            this.errorMsg = '';
            this.uploadDisabled = true;
            this.codeValue = res.res;
          } else {
            this.errorMsg = `<div>${res.msg}</div>`;
            this.uploadDisabled = false;
          }
        })
      },
      checkFile(file){
        // this.loading = true;
        this.fileName = file.name;
        const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        const extension = testmsg === 'jpg'
        const extension2 = testmsg === 'jpeg'
        const extension3 = testmsg === 'png'
        if (!extension && !extension2 && !extension3) {
          this.errorMsg = '上传图片只能是 JPG 、JPEG 或 PNG 格式，请重新上传！';
          // this.loading = false;
          return false
        } else if (file.size > 2 * 1024 * 1024) {
          this.errorMsg = '上传图片大小不能超过2MB！';
          // this.loading = false;
          return false
        } else {
          return true
        }
      },
      handleClose(codeValue) {
        if(typeof codeValue === 'string'){
          this.$emit('cancelCodeDialog', codeValue)
        }
        this.$emit('cancelCodeDialog')
      },
      saveCode() {
        if(this.errorMsg){
          return;
        }
        if(!this.codeValue){
          this.errorMsg = '请上传二维码图片！';
          return;
        }
        this.handleClose(this.codeValue);
        // this.$emit('refeshData')
      }
    }
  };
</script>
<style lang="less" scoped>
.dialogCode{
  /deep/ .el-dialog__body{
    padding: 20px 32px;
  }
  .saveCode{
    /deep/ .el-upload-dragger{
      background: #F4F6FA;
      border-radius: 4px;
      border: 1px solid #E6E8EC;
      position: relative;
      text-align: center;
      .imgClass{
        width: 35px;
        height: 33px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -80%);
      }
      .textClass{
        position: relative;
        top: 138px;
        font-weight: 400;
        color: #A3A5A9;
        line-height: 14px;
      }
    }
  }
  .errorMsg{
    white-space: pre-line;
    color: #f56c6c;
    max-height: 100px;
    overflow-y: auto;
  }
}
</style>